import CryptoJS from 'crypto-js';
import moment from 'moment';
import axios from 'axios';


// export const URL = "http://localhost:8000/";
// export const URL_SOCKET = "http://localhost:5001";
export const DEBUG = false;


// export const URL = "http://192.168.0.222:8000/";
// export const URL_SOCKET = "http://192.168.0.222:5001";
// export const THIS_URL = "http://localhost:3001";
// export const URL = "http://ec2-54-233-173-205.sa-east-1.compute.amazonaws.com/";
export const URL = "https://api.ontest.com.br/";
export const URL_SOCKET = "https://node.ontest.com.br";
export const THIS_URL = "https://candidato.ontest.com.br";

export const TURN_1 = "turn1.ontest.com.br";
export const TURN_2 = "turn2.ontest.com.br";
export const TURN_3 = "turn3.ontest.com.br";
export const TURN_4 = "turn4.ontest.com.br";

// export const URL = "https://onteste.enterscience.com.br/";
// export const URL_SOCKET = "https://node.enterscience.com.br";

// export const TURN_1 = "turn1.enterscience.com.br";
// export const TURN_2 = "turn2.enterscience.com.br";
// export const TURN_3 = "turn3.enterscience.com.br";
// export const TURN_4 = "turn4.enterscience.com.br";



// export const URL = "https://onteste.itec.edu.br/";
// export const URL_SOCKET = "https://node.itec.edu.br";

// export const TURN_1 = "turn1.itec.edu.br";
// export const TURN_2 = "turn2.itec.edu.br";
// export const TURN_3 = "turn3.itec.edu.br";
// export const TURN_4 = "turn4.itec.edu.br";
const key_ = '01234567890123456789012345678901';
export const SOCKET_API_ENCRYPTION_KEY = '';
export const API_ENCRYPTION_KEY = 'sk_live_kokNYsEWUm2LI4x0jFKr7cT7ll6D3ErD';
let encryptedApiResponsesInstalled = false;

export function getSocketApiEncryptionKey() {
    return SOCKET_API_ENCRYPTION_KEY || '';
}

export function getApiEncryptionKey() {
    return API_ENCRYPTION_KEY || '';
}

export function hasSocketApiEncryptionKey() {
    return getSocketApiEncryptionKey() !== '';
}

function envelopeToJson(envelope) {
    const key = getApiEncryptionKey();
    if (!key || envelope == null || envelope.__encrypted !== true || !envelope.payload || !envelope.iv) {
        return envelope;
    }

    const keyHash = CryptoJS.SHA256(key);
    const iv = CryptoJS.enc.Base64.parse(envelope.iv);
    const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Base64.parse(envelope.payload) }, keyHash, { iv: iv });
    const text = CryptoJS.enc.Utf8.stringify(decrypted);

    return JSON.parse(text);
}

export function encryptSocketValue(value) {
    const key = getSocketApiEncryptionKey();
    if (!key || typeof value === 'function') {
        return value;
    }

    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), CryptoJS.SHA256(key), { iv: iv });

    return {
        __encrypted: true,
        payload: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
        iv: iv.toString(CryptoJS.enc.Base64)
    };
}

export function decryptSocketValue(value) {
    return envelopeToJson(value);
}

export function installEncryptedApiResponses() {
    if (encryptedApiResponsesInstalled || typeof window === 'undefined' || !window.fetch) {
        return;
    }

    const originalFetch = window.fetch.bind(window);
    axios.interceptors.request.use((config) => {
        const key = getApiEncryptionKey();
        const url = config && config.url ? config.url : '';

        if (key && String(url).indexOf('/api/') !== -1) {
            config.headers = config.headers || {};
            config.headers['X-Accept-Encrypted-Response'] = 'true';
        }

        return config;
    });

    axios.interceptors.response.use((response) => {
        if (response && response.headers && response.headers['x-encrypted-response'] === 'true') {
            response.data = envelopeToJson(response.data);
        }

        return response;
    });

    window.fetch = async function (input, init = {}) {
        const key = getApiEncryptionKey();
        const headers = new Headers(init.headers || {});
        const url = typeof input === 'string' ? input : input.url;

        if (key && String(url).indexOf('/api/') !== -1) {
            headers.set('X-Accept-Encrypted-Response', 'true');
            init = { ...init, headers };
        }

        const response = await originalFetch(input, init);

        if (!key || response.headers.get('X-Encrypted-Response') !== 'true') {
            return response;
        }

        try {
            const envelope = await response.clone().json();
            const decrypted = envelopeToJson(envelope);
            const responseHeaders = new Headers(response.headers);
            responseHeaders.delete('X-Encrypted-Response');

            return new Response(JSON.stringify(decrypted), {
                status: response.status,
                statusText: response.statusText,
                headers: responseHeaders
            });
        }
        catch (e) {
            console.log('API response decrypt catch', e && e.stack ? e.stack : e);
            return response;
        }
    };

    encryptedApiResponsesInstalled = true;
}

export function encrypt(msg, pass=key_) {


    const key = pass;
    const keyutf = CryptoJS.enc.Utf8.parse(key);
    const iv = CryptoJS.enc.Utf8.parse('678025308de70905');
    const enc = CryptoJS.AES.encrypt(msg, keyutf, { iv: iv });

    var transitmessage = enc.toString();
    console.log(moment().format('YYYY-MM-DD HH:mm:ss'))
    console.log(msg)
    console.log(transitmessage)
    return transitmessage;
}

export function decrypt(transitmessage, pass=key_) {
    if (transitmessage.data==undefined) {
        return transitmessage;
    }
    const keyutf = CryptoJS.enc.Utf8.parse(pass);
    const iv = CryptoJS.enc.Utf8.parse('678025308de70905');
    const dec = CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Base64.parse(transitmessage.data) },
        keyutf,
        {
            iv: iv
        });
    const decStr = CryptoJS.enc.Utf8.stringify(dec)
    // console.log('decStr', decStr);
    return JSON.parse(decStr);
}
